export interface RelatedLink {
  id: string;
  label: string;
  href: string;
  /** Short verb-phrase shown before the link in the footer (e.g. "Also
   *  runs", "Inspired by", "Built on top of"). Omit for entries that
   *  read fine as a standalone label. */
  footerPrefix?: string;
  /** Short hyphenated description appended after the link in the footer
   *  (e.g. "handcrafted pet memorial cards"). */
  blurb?: string;
  /** Placeholder entries not yet wired up — render as a muted "(soon)"
   *  span instead of a live link. */
  comingSoon?: boolean;
}

/** Single source of truth for outbound links shown in the page footer.
 *  Add new entries here as they appear — the footer will pick them up. */
export const RELATED_LINKS: RelatedLink[] = [
  {
    id: 'pawsympathy',
    label: 'PawSympathy',
    href: 'https://pawsympathy.com',
    footerPrefix: 'Need a finished one? Try',
    blurb: 'handcrafted pet memorial cards',
  },
  {
    id: 'more-tools',
    label: 'More tools',
    href: '#',
    comingSoon: true,
  },
];
